export default () => {
  return {
    title: "Acuracidade",
    value: "91%",
    // subtitle: currencyFormatter.format(NetAmount),
  };
};
